import { Grid } from "@material-ui/core";
import React from "react";
import { Route } from "react-router-dom";
import Navbar from "VideoPlace/Navbar/Navbar";

export default function TemplateVideoPlace({ routes }) {
  return (
    <div>
      <Grid container alignItems="flex-start" justifyContent="flex-start">
        <Grid item xs={12}>
          <Navbar />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            background:
              "linear-gradient(145deg, #a89200, #990000, #9c008f, #001c9c, #02979c)",
            //"linear-gradient(145deg, #bfa600, #bf0000, #c700b7, #0024c7, #00b7bd)",
            //background: "linear-gradient(145deg, #ffdd00,#292929, #910085)",
          }}
        >
          {routes.map((route) => {
            return (
              <Route
                path={route.path}
                exact={route.exact}
                component={route.component}
              />
            );
          })}
        </Grid>
      </Grid>
    </div>
  );
}
